import React, { Component } from "react";

import {
  CCard,
  CCardHeader,
  CCardBody,
  CButton,
  CSpinner
} from "@coreui/react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

import { logout } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import Breadcrumb from "../../../../components/Breadcrumb";
import Form from "../../../../components/Forms/Form";
import {
  alphaNumeric,
  required
} from "../../../../components/Forms/validators";
import Loading from "../../../../components/Loading";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";

class LearningAreaCreate extends Component {
  constructor(props) {
    super(props);

    this.state = {
      edit: false,
      // user: {},
      loading: false,
      creating: false
    };

    this.formRef = React.createRef();
    this.error = this.error.bind(this);
    this.enviar = this.enviar.bind(this);
    this.atualizar = this.atualizar.bind(this);
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Falha", response);
    }
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);

    const { id } = this.props.match.params;
    if (id) {
      this.setState(
        () => ({
          loading: true
        }),
        () => {
          axios
            .get(`${URL.api}classification/learning_area/singleView/${id}`, {
              headers: { authorization: `Bearer ${this.props.user.token}` }
            })
            .then(
              resp => {
                this.setState(
                  () => ({
                    learningAreas: resp.data.data
                  }),
                  () => {
                    this.setState(() => ({
                      edit: true,
                      loading: false
                    }));
                  }
                );
              },
              error => {
                this.error("Não foi possível carregar as informações");
              }
            );
        }
      );
    }
  }

  enviar(value) {
    this.setState({ creating: true });

    let obj = {
      name: value.name
    };

    axios
      .post(`${URL.api}classification/learning_area/insert`, obj, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          if (resp.data.success) {
            this.props.history.push("/learningArea/list");
            this.setState({ creating: false });
          } else {
            this.error("Não foi possível criar a área do conhecimento");
            this.setState({ creating: false });
          }
        },
        error => {
          this.error("Não foi possível criar a área do conhecimento");
          this.setState({ creating: false });
        }
      );
  }

  atualizar(value) {
    this.setState({ creating: true });

    let obj = {
      name: value.name
    };

    axios
      .post(`${URL.api}classification/learning_area/update/${value.id}`, obj, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          if (resp.data.success) {
            this.props.history.push("/learningArea/list");
            this.setState({ creating: false });
          } else {
            this.error("Não foi possível editar a área do conhecimento");
            this.setState({ creating: false });
          }
        },
        error => {
          this.error("Não foi possível editar a área do conhecimento");
          this.setState({ creating: false });
        }
      );
  }

  render() {
    const Fields = [
      {
        name: "name",
        label: "Nome",
        type: "text",
        required: true,
        icon: "fa fa-text-width",
        value: "",
        validate: [required, alphaNumeric]
      }
    ];

    return (
      <>
        <Breadcrumb
          current={this.props.currentRoute}
          items={[{ path: "/LearningArea/list", to: "/LearningArea/list" }]}
        />
        {this.state.loading ? (
          <Loading />
        ) : (
          <CCard>
            <CCardHeader className="d-flex align-items-center">
              <div
                style={{ display: "flex", flexDirection: "column", flex: 1 }}
              >
                <h4 className="card-title mb-1">
                  {this.state.edit
                    ? "Editar Área do Conhecimento"
                    : "Criar Área do Conhecimento"}
                </h4>
                <div className="small text-muted">
                  {this.state.edit
                    ? "Edite a área do conhecimento selecionada"
                    : "Crie uma nova área do conhecimento"}
                </div>
              </div>
              <CButton
                color="primary"
                className="d-flex justify-content-center align-items-center"
                onClick={() => this.formRef.current.submit()}
                disabled={this.state.creating}
              >
                <>
                  <span style={this.state.creating ? { opacity: 0 } : null}>
                    <i className="fa fa-cloud-upload mr-2"></i>Salvar
                  </span>
                  {this.state.creating && (
                    <CSpinner
                      size="sm"
                      color="white"
                      style={{ position: "absolute" }}
                    />
                  )}
                </>
              </CButton>
            </CCardHeader>
            <CCardBody>
              <Form
                avatar
                fields={Fields}
                history={this.props.history}
                onSubmit={this.state.edit ? this.atualizar : this.enviar}
                initialValues={this.state.learningAreas}
                edit={this.state.edit}
                ref={this.formRef}
              />
            </CCardBody>
          </CCard>
        )}
        <ProtectedRoute routeId={this.props.currentRoute} />
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(LearningAreaCreate);
